import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { getNumberComma } from '../../utils/numberUtils';

const TaxBillDetail = ({ taxbill, roInfo }) => {
  return (
    <>
      <Box>
        <Grid
          item
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
        >
          <Grid item xs={2}>
            <Typography variant="subtitle2" component="div">
              {' '}
              계약서 번호
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="body2" component="div">
              {taxbill?.invNo}
            </Typography>
          </Grid>
          <Grid item xs={2}>
            {/* <Typography variant="subtitle2" component="div">매입매출번호</Typography> */}
          </Grid>
          <Grid item xs={4}>
            {/* <Typography variant="body2" component="div"> {taxbill?.billUuid}</Typography> */}
          </Grid>
        </Grid>
        <Grid
          item
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
        >
          <Grid item xs={2}>
            <Typography variant="subtitle2" component="div">
              {' '}
              유형
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="body2" component="div">
              {' '}
              {taxbill?.invTyp}
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography variant="subtitle2" component="div">
              매입(매출)처
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="body2" component="div">
              {taxbill?.partnerNm}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          item
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
        >
          <Grid item xs={2}>
            <Typography variant="subtitle2" component="div">
              계산서 금액
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="body2" component="div">
              {getNumberComma(taxbill?.invAmt)}
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography variant="subtitle2" component="div">
              프로젝트번호
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="body2" component="div">
              {roInfo?.prjNo}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          item
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
        >
          <Grid item xs={2}>
            <Typography variant="subtitle2" component="div">
              VAT
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="body2" component="div">
              {getNumberComma(taxbill?.invVat)}
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography variant="subtitle2" component="div">
              프로젝트명
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="body2" component="div">
              {roInfo?.prjNm}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          item
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
        >
          <Grid item xs={2}>
            <Typography variant="subtitle2" component="div">
              전체금액
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="body2" component="div">
              {getNumberComma(taxbill?.invTot)}
            </Typography>
          </Grid>
          <Grid item xs={2}></Grid>
          <Grid item xs={4}></Grid>
        </Grid>
        <Grid
          item
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
        >
          <Grid item xs={2}>
            <Typography variant="subtitle2" component="div">
              영업담당자
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="body2" component="div">
              {roInfo?.salesNm}
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography variant="subtitle2" component="div">
              담당자 이메일
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="body2" component="div">
              {roInfo?.salesEml}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default TaxBillDetail;
